export default "__VITE_ASSET__BGcvuFOk__"